<template lang="pug">
.ncons.epw-ncons.active
  .accepted-payments.mb-2
    small {{$t('ui.payment_list')}}:
    .apm
      img(src='/images/depo/bank/cc.png')
      img(src='/images/depo/bank/digi.png')
      img(src='/images/depo/bank/mx.png')
      img(src='/images/depo/bank/um.png')
      img(src='/images/depo/bank/tng.png')
  .mb-3
    label.col-form-label {{ $t('ui.payment_option') }}
    .select-image
      .select-image-input(@click="toggleList" v-if="selectedOption===''")
        | {{ $t('ui.please_select_bank') }}
      .select-image-input(@click="toggleList" v-else)
        .select-image-option
          img(:src="'/images/depo/bank/' + paymentImg + '.png'" alt :value="selectedOption")
          |  {{ paymentName }}
      .select-image-list.mb-2(:class="{'show': showList}")
        .select-image-option(v-for="(option,i) in paymentOption" @click="checkOption($event, i)")
          img(:src="'/images/depo/bank/' + option.img + '.png'" alt :value="option.id")
          |  {{ option.name }}

    //- select.form-control(v-model.trim="$v.selectedOption.$model" @change="checkOption")
      option(disabled="" selected="" value="") {{ $t('ui.payment_option') }}
      option(v-for="option in paymentOption" :value="option.id") {{ option.name }}
    .error.w-100(v-if="$v.selectedOption.$model == '' && $v.selectedOption.$dirty")
      small.text-danger.form-text {{ $t('ui.please_select_payment') }}
  .mb-3
    label.col-form-label {{ $t('ui.amount') }} ({{ $t("ui.min") }} {{ $t("ui.amount") }}:  {{ this.$store.getters.currencyCode }} {{ $numeral(minSettingDeposit).format("0,0.00") }})
    .d-flex.gap-2
      input.form-control(:class="{'disable-display': promoId !== ''}" type="text" :placeholder="'eg. ' + minSettingDeposit" v-model.trim="$v.mytelcoDeposit.$model" @keypress="$helpers.onlyNumber"  :disabled="promoId !== ''" @input="handleInputChange")
    ValidateResult(:value="$v.mytelcoDeposit" :name="$t('ui.amount')")
    .quickamo-wrap.mt-2
      a.quickamo(href="javascript:void(0)" @click="fillAmount(30, 1)" :class="{'active': quickamo==1}") RM 30
      a.quickamo(href="javascript:void(0)" @click="fillAmount(50, 2)" :class="{'active': quickamo==2}") RM 50
      a.quickamo(href="javascript:void(0)" @click="fillAmount(100, 3)" :class="{'active': quickamo==3}") RM 100
      a.quickamo(href="javascript:void(0)" @click="fillAmount(200, 4)" :class="{'active': quickamo==4}") RM 200
      a.quickamo(href="javascript:void(0)" @click="fillAmount(300, 5)" :class="{'active': quickamo==5}") RM 300
      a.quickamo(href="javascript:void(0)" @click="fillAmount(400, 6)" :class="{'active': quickamo==6}") RM 400
  .mb-3
    label.col-form-label {{ $t('ui.reloadpincode') }}
    input.form-control#deposit-mytelco-reload(type="text" v-model.trim="$v.reloadPinCode.$model" @keypress="$helpers.onlyNumber"  minlength="10")
    ValidateResult(:value="$v.reloadPinCode" :name="$t('ui.reloadpincode')")
  .mb-3.text-center
    router-link.deposit-btn(v-if="isDirtyValid()" :to="'/mytelco?telcoCode='+ selectedOption + '&reloadPinCode=' + reloadPinCode +'&amount=' + mytelcoDeposit + '&bank=MYTELCO&promo=' + promoId" target="_blank" @click.native="mytelcoSubmit") {{ $t('ui.deposit') }}
    button.login-btn(v-else @click.stop="$v.$touch();") {{ $t('ui.deposit') }}
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags"
import ValidateResult from "@/library/ValidateResult"
import {required, minLength, maxLength, sameAs, not, minValue, alphaNum} from "vuelidate/lib/validators"

export default {
  components: {
    ValidateResult,
  },
  props: {
    minSettingDeposit: {
      type: Number,
      default: 0.0
    },
    promotionList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      mytelcoDeposit: "",
      reloadPinCode: "",
      // conditionChecked: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      getFreeSpin:false,
      freeSpinAmount: 0,
      // freeSpinAmount: 0,
      // premiumSpin: false
      // euroTicket: false,
      ticketAmount: 0,
      selectedOption: "",
      paymentName: "",
      paymentImg: "",
      // paymentOption: paymentList.payment_method
      paymentOption: [
        {id: "maxis", name: "MAXIS", img: "mx"},
        {id: "digi", name: "DIGI", img: "digi"},
        {id: "celcom", name: "CELCOM", img: "cc"},
        {id: "umobile", name: "UMOBILE", img: "um"},
        {id: "tng", name: "TNG", img: "tng"},
      ],
      promoId: "",
      quickamo: 0,
      showList: false
    }
  },
  validations() {
    return {
      selectedOption: {
        required
      },
      mytelcoDeposit: {
        required,
        minValue: minValue(this.minSettingDeposit)
      },
      reloadPinCode:{
        required,
        minLength: minLength(10),
        maxLength: maxLength(16),
      },
      // conditionChecked: {
      //   required(val) {
      //     return val;
      //   }
      // }
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  destroyed(){
  },
  mounted() {
    // if(this.promoSelected.package_id !== '0'){
    //   this.mytelcoDeposit = this.promoSelected.package_amount;
    // }
    // if(this.defaultShow) {
    //   $('#deposit-gateway').trigger('focus')
    // }
    // var vm = this;
    // $("#modal-deposit").on("hidden.bs.modal", function() {
    //   vm.reset()
    // })
  },
  methods: {
    toggleList(){
      this.showList = !this.showList
    },
    handleInputChange(){
      this.quickamo = 0
    },
    checkOption(e, i){
      if(this.paymentOption) {
        this.selectedOption = this.paymentOption[i].id
        this.paymentName = this.paymentOption[i].name
        this.paymentImg = this.paymentOption[i].img
        this.toggleList()
      }
    },
    checkFreeSpins(amount){
      var formatNumber = Number(amount);
      if(formatNumber < 50){
        this.getFreeSpin = false;
        // this.freeSpinAmount = 0;
        // this.premiumSpin = false;
        // this.euroTicket = false;
        this.ticketAmount = 0;      
      }else{
        this.getFreeSpin = true;
        // this.euroTicket = true;
        switch(true){
          case (formatNumber >=50 && formatNumber < 100):
            // this.freeSpinAmount = 2
            // this.premiumSpin = false;
            this.ticketAmount = 1;           
          break;
          case (formatNumber >=100 && formatNumber < 200):            
            // this.freeSpinAmount = 10
            // this.premiumSpin = false;
            this.ticketAmount = 3;
          break;
          case (formatNumber >= 200 && formatNumber < 500):
            // this.freeSpinAmount = 5
            // this.premiumSpin = true;
            this.ticketAmount =7;
          break;
          case (formatNumber >= 500 && formatNumber < 1000):
            // this.freeSpinAmount = 10
            // this.premiumSpin = true;
            this.ticketAmount = 10;
          break;
          case (formatNumber >= 1000):
            // this.freeSpinAmount = 50
            // this.premiumSpin = true;
            this.ticketAmount = 13;
          break;
          default:
            // this.freeSpinAmount = 0
            // this.premiumSpin = false;
            this.ticketAmount = 0;
        }
      }
    },
    fillAmount(amount, target){
      this.quickamo = target
      this.mytelcoDeposit = amount;
      // this.checkFreeSpins(amount);
      this.$v.$touch()
    },
    isDirtyValid() {
      // this.$v.$touch()
      
      // return this.$v.$dirty && !this.$v.$invalid
      return !this.$v.$invalid
    },
    reset() {
      // this.tempDeposit = this.mytelcoDeposit
      this.mytelcoDeposit = ""
      this.reloadPinCode = ""
      this.feedback.success = true
      this.feedback.status = ""
      // this.conditionChecked = false
      this.getFreeSpin = false
      this.$v.$reset()
    },
    mytelcoSubmit() {
      this.$router.push({
        name:"statement",
        params:{
          "checkTrans": true
        }
      }).catch(error =>{})
    }
  }
}
</script>
<style lang="scss" scoped>
.bank-logo-wapper{
  justify-content: end;
}
</style>